<tt-page *ngIf="!!setting">
    <tt-page-heading *ngIf="!!setting.page_heading" [ttModel]="setting.page_heading"></tt-page-heading>

    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-checkbox ttLabel="show_all" [(ttModel)]="setting.show_all" (ttModelChange)="onChanged($event, 'show_all')"></tt-checkbox>
            <tt-button-goto ttText="deviationtypes_new" ttGoto="deviationtype" [ttGotoParms]="{ deviationtype_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
        </tt-card>

        <tt-list [ttData]="itemsListDeviationTypes"></tt-list>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-4 p-5">
                <tt-checkbox ttLabel="show_all" [(ttModel)]="setting.show_all" (ttModelChange)="onChanged($event, 'show_all')"></tt-checkbox>
            </tt-card>

            <tt-card class="col-xs-12 col-md-2 p-5">
                <tt-button-goto ttText="deviationtypes_new" ttGoto="deviationtype" [ttGotoParms]="{ deviationtype_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
            </tt-card>
        </div>

        <tt-list class="col-xs-12 col-md-4 p-5" [ttData]="itemsListDeviationTypes"></tt-list>
    </div>
</tt-page>
